import cx from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import webpushHelper, { isWebPushSupported, WEBPUSH_STATUS } from 'utils/webpushHelper';
import { saveWebpushTokenAction, blockNotificationPreferences } from 'actions/webpushActions';
import { hideModal } from 'actions/modalActions';
import StringWidget from 'components/StringWidget/StringWidget';
import omnitureHelper from 'utils/omnitureHelper';
import fdpHelper from 'utils/FDPHelper';
import HowToUnblock from 'widgets/RichAccordian/HowToUnblock/HowToUnblock';
import { getBrowserDetails } from 'utils/userAgentUtils';
import imgArrow from 'images/webpusharrow.svg';
import withToast from 'components/Toast/withToast';
import styles from './PushNotificationWidget.css';
import getImageUrl from 'utils/getImageUrl';
export var STATES;
(function (STATES) {
    STATES["INTERNAL_PROMPT"] = "INTERNAL_PROMPT";
    STATES["NATIVE_PROMPT"] = "NATIVE_PROMPT";
    STATES["DISMISS"] = "DISMISS";
})(STATES || (STATES = {}));
export class PushNotificationWidget extends Component {
    constructor(props) {
        super(props);
        this.allowWebPushAnaltytics = () => {
            omnitureHelper.trackLink({
                prop20: 'WebPush_BR_OC_Allow',
                events: 'event98'
            }, 'NotificationPermissionResponse');
            fdpHelper.trackEvent({
                en: 'OWSC',
                an: 'fkwebsite',
                act: 'Allow',
                pt: 'openweb'
            });
        };
        this.webPushDeniedAnalytics = () => {
            omnitureHelper.trackLink({ prop20: 'WebPush_BR_OC_Block' }, 'NotificationPermissionResponse');
            fdpHelper.trackEvent({
                en: 'OWSC',
                an: 'fkwebsite',
                act: 'Denied',
                pt: 'openweb'
            });
        };
        this.registerWebPush = () => {
            return new Promise((resolve, reject) => {
                webpushHelper
                    .subscribe()
                    .then(subscription => {
                    // Subscribe to Connekt by making register call.
                    this.props.saveWebpushToken(subscription);
                    resolve();
                })
                    .catch(() => {
                    reject();
                });
            });
        };
        this.handleAllow = (action) => {
            const { handleAllowNotify, onSuccess, onFailure } = this.props;
            this.registerWebPush()
                .then(() => {
                // Call custom api on Allow success by passing the method in handleAllowNotify.
                if (handleAllowNotify && typeof handleAllowNotify === 'function') {
                    handleAllowNotify();
                }
                this.allowWebPushAnaltytics();
                // Hide modal after successful subscription, handled via caller who is showing modal
                // passing onSuccess message for the same.
                const message = (action && get(action, ['params', 'message'])) || '';
                onSuccess && onSuccess({ message });
            })
                .catch(() => {
                // call block api when status is denied.
                const permission = webpushHelper.getWebPushPermissionStatus();
                const callBackProps = {
                    extraParams: {
                        permission: WEBPUSH_STATUS.DENIED
                    }
                };
                /* consider the reactivation flow here hence send the data with
                 * WEBPUSH_STATUS.DENIED for proper UI handelling
                 */
                this.setState({
                    viewState: STATES.INTERNAL_PROMPT,
                    currentPermission: WEBPUSH_STATUS.DENIED
                }, () => {
                    onFailure && onFailure(callBackProps);
                });
                if (permission === WEBPUSH_STATUS.DENIED) {
                    this.props.blockNotificationPreferences();
                    this.webPushDeniedAnalytics();
                }
                else {
                    omnitureHelper.trackLink({ prop20: 'WebPush_BR_OC_Close' }, 'NotificationPermissionResponse');
                }
            });
            omnitureHelper.trackLink({ prop20: 'WebPush_Internal_OC_Allow' }, 'OC_WebPush_Internal_Response');
        };
        this.handleNotNow = () => {
            this.props.onFailure && this.props.onFailure({ extraParams: { hideModal: true } });
            omnitureHelper.trackLink({ prop20: 'WebPush_Internal_OC_Deny' }, 'OC_WebPush_Internal_Response');
        };
        this.handleAction = (action) => () => {
            const type = action && action.type;
            if (type === 'DISMISS') {
                this.handleNotNow();
            }
            else if (type === 'ALLOW') {
                this.setState({
                    viewState: STATES.NATIVE_PROMPT
                }, () => {
                    this.handleAllow(action);
                });
            }
        };
        const currentPermission = (isWebPushSupported() && webpushHelper.getWebPushPermissionStatus()) || WEBPUSH_STATUS.DENIED;
        this.state = {
            viewState: STATES.INTERNAL_PROMPT,
            currentPermission
        };
    }
    componentDidMount() {
        const { currentPermission } = this.state;
        if (currentPermission === WEBPUSH_STATUS.DEFAULT) {
            omnitureHelper.trackLink({ events: 'event8' }, 'OC_WebPush_Internal_Shown');
        }
    }
    renderPrompt() {
        const componentData = get(this.props, ['data', 'content', 0, 'value']) || {};
        const { promptText } = this.props;
        const description = componentData.description || promptText;
        const imageSrc = getImageUrl(get(componentData, ['image', 'dynamicImageUrl']), '900');
        const actions = get(this.props, ['data', 'actions']);
        const permission = this.state.currentPermission;
        let actionInfoUi;
        let textClass = cx(styles['msg-allow'], styles['push-message']);
        if (permission === WEBPUSH_STATUS.DENIED) {
            actionInfoUi = <HowToUnblock className={styles['how-to-unblock']}/>;
            textClass = styles['msg-allow'];
        }
        else {
            actionInfoUi = (<div className={styles['push-actions']}>
					{actions.map(actionButton => {
                const buttonText = get(actionButton, ['value', 'text']);
                const action = actionButton.action;
                const type = get(actionButton, ['value', 'actionType']) || '';
                let styleClass = styles['success-btn'];
                switch (type) {
                    case 'WEBPUSH_OPTIN_DISMISS':
                        styleClass = styles['push-not-now-btn'];
                        break;
                    case 'WEBPUSH_OPTIN_ALLOW':
                    case 'WEBPUSH_OPTIN_NOTNOW':
                    default:
                        styleClass = styles['success-btn'];
                        break;
                }
                return (<button key={`${type}_${buttonText}`} className={styleClass} onClick={this.handleAction(action)}>
								{buttonText}
							</button>);
            })}
				</div>);
        }
        return (<div className={cx(styles['push-prompt'], styles['showquick'])}>
				<div className={styles['push-msg-prompt']}>
					<img src={imageSrc} className={styles['image']}/>
					<div className={textClass}>{description}</div>
				</div>
				{actionInfoUi}
			</div>);
    }
    renderOverlay() {
        const browserDetils = getBrowserDetails();
        const browserName = get(browserDetils, 'name');
        const isEdge = browserName === 'Edge';
        // Since Edge browser shows allow popup on bottom of the screen, we need to change UI accordingly.
        return (<div className={styles['push-overlay']}>
				<div className={styles['push-info']}>
					{!isEdge && (<div>
							<img src={imgArrow} className={styles['image']}/>
						</div>)}
					<StringWidget strKey="webAPINotificationAlmost" className={styles['msg']}/>
					<StringWidget strKey={isEdge ? 'webpushEdgeOverlayMessage' : 'webpushOverlayMessage'}/>
					{isEdge && (<div className={cx({ [styles['edge']]: isEdge })}>
							<img src={imgArrow} className={styles['image']}/>
						</div>)}
				</div>
			</div>);
    }
    render() {
        const { viewState } = this.state;
        if (viewState === STATES.INTERNAL_PROMPT) {
            return this.renderPrompt();
        }
        else if (viewState === STATES.NATIVE_PROMPT) {
            return this.renderOverlay();
        }
        return null;
    }
}
const mapDispatchToProps = {
    saveWebpushToken: saveWebpushTokenAction,
    blockNotificationPreferences,
    hideModal
};
export default connect(null, mapDispatchToProps)(withToast(PushNotificationWidget));
